var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 52,
    viewBox: "0 0 98 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_785_3964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.919 50.1681H44.3253V0.0375977L37.082 2.24048V48.3589C37.082 49.3561 37.9059 50.1681 38.919 50.1681Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.14 33.0967L21.7642 32.7239C24.363 31.1819 26.3493 29.0311 27.6665 26.3355C29.0842 23.4327 29.7561 20.157 29.7203 16.3156L29.7084 13.0609L22.4096 15.1882L22.3171 18.1613C22.2338 19.1521 22.1517 20.0893 21.9533 20.9978C21.1056 24.8652 18.8838 27.1971 15.1518 28.1317C12.9022 28.6948 10.6236 28.6636 8.21135 28.6336L7.35701 28.6218V0H0V50.2192H7.40331V35.3191L8.0857 35.31C8.39516 35.3061 8.7086 35.3035 9.01806 35.2995C10.5865 35.2813 12.1868 35.2656 13.7724 35.1536L14.1771 35.1262L14.3993 35.4599C16.2507 38.2311 18.1393 41.0218 19.9656 43.7213C21.2339 45.5958 22.5021 47.4727 23.7651 49.3498C24.1804 49.9689 24.7305 50.2674 25.4486 50.2674H25.4989C26.5411 50.2465 27.6202 50.2505 28.571 50.2544H28.7179C29.0643 50.2556 29.4095 50.257 29.7561 50.257L33.0755 50.2661L32.5147 49.5114L21.14 33.0967Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2489 42.3984C87.7496 42.3984 84.9102 45.1957 84.9102 48.6461C84.9102 49.2521 85.0001 49.8348 85.1641 50.3888H97.3337C97.4963 49.8348 97.5863 49.2521 97.5863 48.6461C97.5875 45.1957 94.7508 42.3984 91.2489 42.3984Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1822 38.09V19.6875L51.1016 21.4576V38.09C51.1016 45.6906 56.3611 50.9997 63.8875 50.9997C67.0099 50.9997 69.4724 49.9517 70.9879 49.0732L72.7798 48.0356V50.4014H79.8604V19.7291L72.7798 21.4132V36.8948C72.7798 41.8871 69.9313 44.8681 65.1623 44.8681C61.052 44.8707 58.1822 42.0839 58.1822 38.09Z",
    fill: "#9C9C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_3964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.5865,
    height: 51.2329,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlu);
export default __webpack_public_path__ + "static/media/Klu.156494c21b7a5b5d2250398c52db0559.svg";
export { ForwardRef as ReactComponent };